import React from 'react'

const OldFypProjects = () => {
  return (
    <div>OldFypProjects</div>
  )
}

export default OldFypProjects